import React from 'react';
import { Badge } from '../catalyst/badge';
import type { OrderStatus, PaymentStatus, ProdigiStatus, LobStatus, CodeStatus } from '../types/database';

const orderStatusColors: Record<OrderStatus, string> = {
	DRAFT: 'zinc',
	IN_REVIEW: 'amber',
	PENDING_PAYMENT: 'orange',
	PAID: 'green',
	FULFILLING: 'blue',
	SHIPPED: 'indigo',
	DELIVERED: 'emerald',
	CANCELLED: 'red',
};

const orderStatusLabels: Record<OrderStatus, string> = {
	DRAFT: 'Draft',
	IN_REVIEW: 'In Review',
	PENDING_PAYMENT: 'Pending Payment',
	PAID: 'Paid',
	FULFILLING: 'Fulfilling',
	SHIPPED: 'Shipped',
	DELIVERED: 'Delivered',
	CANCELLED: 'Cancelled',
};

const paymentStatusColors: Record<PaymentStatus, string> = {
	PENDING: 'zinc',
	PROCESSING: 'amber',
	SUCCEEDED: 'green',
	FAILED: 'red',
	CANCELLED: 'red',
	REFUNDED: 'orange',
};

const paymentStatusLabels: Record<PaymentStatus, string> = {
	PENDING: 'Pending',
	PROCESSING: 'Processing',
	SUCCEEDED: 'Succeeded',
	FAILED: 'Failed',
	CANCELLED: 'Cancelled',
	REFUNDED: 'Refunded',
};

const prodigiStatusColors: Record<ProdigiStatus, string> = {
	DRAFT: 'zinc',
	AWAITING_PAYMENT: 'amber',
	IN_PROGRESS: 'blue',
	COMPLETE: 'emerald',
	CANCELLED: 'red',
};

const prodigiStatusLabels: Record<ProdigiStatus, string> = {
	DRAFT: 'Draft',
	AWAITING_PAYMENT: 'Awaiting Payment',
	IN_PROGRESS: 'In Progress',
	COMPLETE: 'Complete',
	CANCELLED: 'Cancelled',
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
	return (
		<Badge color={orderStatusColors[status] as any}>
			{orderStatusLabels[status] || status}
		</Badge>
	);
}

export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
	return (
		<Badge color={paymentStatusColors[status] as any}>
			{paymentStatusLabels[status] || status}
		</Badge>
	);
}

export function ProdigiStatusBadge({ status }: { status: ProdigiStatus }) {
	return (
		<Badge color={prodigiStatusColors[status] as any}>
			{prodigiStatusLabels[status] || status}
		</Badge>
	);
}

const lobStatusColors: Record<LobStatus, string> = {
	created: 'zinc',
	rendered: 'zinc',
	billed: 'amber',
	mailed: 'blue',
	in_transit: 'blue',
	in_local_area: 'indigo',
	processed_for_delivery: 'indigo',
	delivered: 'emerald',
	re_routed: 'orange',
	returned_to_sender: 'red',
	failed: 'red',
	rejected: 'red',
	deleted: 'red',
	cancelled: 'red',
};

const lobStatusLabels: Record<LobStatus, string> = {
	created: 'Created',
	rendered: 'Rendered',
	billed: 'Billed',
	mailed: 'Mailed',
	in_transit: 'In Transit',
	in_local_area: 'In Local Area',
	processed_for_delivery: 'Processing',
	delivered: 'Delivered',
	re_routed: 'Re-routed',
	returned_to_sender: 'Returned',
	failed: 'Failed',
	rejected: 'Rejected',
	deleted: 'Deleted',
	cancelled: 'Cancelled',
};

export function LobStatusBadge({ status }: { status: LobStatus }) {
	return (
		<Badge color={lobStatusColors[status] as any}>
			{lobStatusLabels[status] || status}
		</Badge>
	);
}

// Code status badge
const codeStatusColors: Record<CodeStatus, string> = {
	active: 'green',
	paused: 'amber',
	expired: 'zinc',
};
const codeStatusLabels: Record<CodeStatus, string> = {
	active: 'Active',
	paused: 'Paused',
	expired: 'Expired',
};
export function CodeStatusBadge({ status }: { status: CodeStatus }) {
	return <Badge color={codeStatusColors[status] as any}>{codeStatusLabels[status] || status}</Badge>;
}
